import { ShoppingCartService } from './shopping-cart.service';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscriber } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs/operators';
import { DSProduct } from 'src/app/modals/dsproduct.modal';
import { RestApiService } from './restapi.service';
import { UserService } from './user.service';
import * as _ from 'lodash';
import { UtilityService } from './utility.service';
import { CompanyService } from './company.service';
import { ConfigService } from './config.service';
import { CORPORATESTOREID, IBOSTOREID, RETAILSTOREID } from 'src/app/constant';


// Get product from sessionStorage (changed from localStorage to prevent caching across sessions)
const products = JSON.parse(sessionStorage.getItem('compareItem')) || [];

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  public catalogMode: boolean = false;
  public allItems: any;
  private url1: string = 'assets/data/';
  public url = 'assets/data/banners.json';

  public compareProducts: BehaviorSubject<any> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;
  public selectedPacks: any = [];
  public selectedOrderItems: any = [];
  public selectedAutoOrderItems: any = [];
  public packs = [];
  public orders = [];
  public autoship = [];
  public IsAllowDynamicCouponcode: boolean = true;
  previousRequest = {};
  userServiceModal: any;
  constructor(
    private httpClient: HttpClient,
    public snackBar: MatSnackBar,
    public apiService: RestApiService,
    public user: UserService,
    public utilityService: UtilityService,
    public companyService: CompanyService,
    public configService: ConfigService,
    public shoppingCartService: ShoppingCartService
  ) {
    this.compareProducts.subscribe(products => products = products);
    this.userServiceModal = this.user.userServiceModal;
    this.init();
  }

  private products(req?: any): Observable<any> {
    // iOS-compatible customer type resolution
    const getCustomerTypeID = () => {
      // Try multiple sources in order of reliability
      if (req?.PriceGroup) return req.PriceGroup;
      
      // Try fresh user service reference first
      if (this.user?.userServiceModal?.customerTypeID) {
        return this.user.userServiceModal.customerTypeID;
      }
      
      // Try customer data directly
      if (this.user?.userServiceModal?.customerData?.CustomerType) {
        return this.user.userServiceModal.customerData.CustomerType;
      }
      
      // Try cached reference
      if (this.userServiceModal?.customerTypeID) {
        return this.userServiceModal.customerTypeID;
      }
      
      // Try localStorage as backup
      try {
        const userService = sessionStorage.getItem('userService');
        if (userService) {
          const parsed = JSON.parse(userService);
          if (parsed.customerTypeID) {
            return parsed.customerTypeID;
          }
        }
      } catch (e) {}
      
      // Try sessionStorage as final backup
      try {
        const sessionCustomerType = sessionStorage.getItem('selectedCustomerTypeID');
        if (sessionCustomerType && sessionCustomerType !== 'undefined') {
          return parseInt(sessionCustomerType);
        }
      } catch (e) {}
      
      // Default to retail (safest option)
      return 2;
    };
    
    const customerTypeID = getCustomerTypeID();
    
    const request = {
      CurrencyCode: req?.CurrencyCode || this.companyService.selectedCurrency?.CurrencyCode || 'USD',
      LanguageCode: req?.LanguageCode || this.configService.commonData.selectedLanguage || 'en',
      RegionID: req?.RegionID || this.companyService.getRegionID(this.userServiceModal?.selectedCountry) ||this.companyService.getRegionID(sessionStorage.getItem('selectedCountry')) || 1,
      PriceGroup: customerTypeID,
      StoreID:  req?.StoreID || (!this.isLoggedIn() && customerTypeID == 1 ? IBOSTOREID : this.user?.userServiceModal?.customerData?.IsCorporate == true ?  CORPORATESTOREID : RETAILSTOREID),
      CategoryId: ''
    };
    return this.apiService.getItemsbyFilter(request).pipe(map(items => {
      this.allItems = items.Data;
      return items.Data;
    }));
  }
  private autoshipProducts(req?: any): Observable<any> {
    // iOS-compatible customer type resolution (same logic as products)
    const getCustomerTypeID = () => {
      if (req?.PriceGroup) return req.PriceGroup;
      
      if (this.user?.userServiceModal?.customerTypeID) {
        return this.user.userServiceModal.customerTypeID;
      }
      
      if (this.user?.userServiceModal?.customerData?.CustomerType) {
        return this.user.userServiceModal.customerData.CustomerType;
      }
      
      if (this.userServiceModal?.customerTypeID) {
        return this.userServiceModal.customerTypeID;
      }
      
      try {
        const userService = sessionStorage.getItem('userService');
        if (userService) {
          const parsed = JSON.parse(userService);
          if (parsed.customerTypeID) {
            return parsed.customerTypeID;
          }
        }
      } catch (e) {}
      
      try {
        const sessionCustomerType = sessionStorage.getItem('selectedCustomerTypeID');
        if (sessionCustomerType && sessionCustomerType !== 'undefined') {
          return parseInt(sessionCustomerType);
        }
      } catch (e) {}
      
      return 2;
    };
    
    const customerTypeID = getCustomerTypeID();
    
    const request = {
      CurrencyCode: req?.CurrencyCode || this.companyService.selectedCurrency?.CurrencyCode || 'USD',
      LanguageCode: req?.LanguageCode || this.configService.commonData.selectedLanguage || 'en',
      RegionID: req?.RegionID || this.companyService.getRegionID(this.userServiceModal?.selectedCountry) ||this.companyService.getRegionID(sessionStorage.getItem('selectedCountry')) || 1,
      PriceGroup: customerTypeID,
      StoreID:  req?.StoreID || (!this.isLoggedIn() && customerTypeID == 1 ? IBOSTOREID : this.user?.userServiceModal?.customerData?.IsCorporate == true ?  CORPORATESTOREID : RETAILSTOREID),
      CategoryId: ''
    };
    return this.apiService.getItemsbyFilter(request).pipe(
      map(items => {
        const filteredItems = items.Data.filter(item => item.AllowAutoship === true);
        this.allItems = filteredItems;
        return filteredItems;
      })
    );
  }

  public banners(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.url);
  }

  // Get Banners
  public getBanners() {
    return this.banners();
  }

  // Get Banners
  public getProducts(request?: any): Observable<Array<DSProduct>> {
    this.previousRequest = this.previousRequest || request;
    if (this.allItems && this.allItems.length > 0 && _.isEqual(this.previousRequest, request)) {
      const itemsStream = new Observable(observer => {
        observer.next(this.allItems);
        observer.complete();
      });
      return <Observable<any>>itemsStream;
    } else {
      return this.products(request);
    }
  }

  // Get Products By Id
  public getProduct(id: number): Observable<any> {
    // if (this.allItems && this.allItems.length > 0) {
    //   console.log("check the allitems",this.allItems)
    //   const product = this.allItems.find((item: any) => {
    //     return item.ItemID == id;
    //   });
    //   const itemsStream = new Observable(observer => {
    //     observer.next(product);
    //     observer.complete();
    //   });
    //   return <Observable<any>>itemsStream;
    // } 
    // else {
      return this.products().pipe(map(items => {
        const products = items;
        return products.find((item: any) => {
          return item.ItemID == id;
        });
      }));
    // }
  }


  /*
---------------------------------------------
----------  Compare Product  ----------------
---------------------------------------------
*/

  // Get Compare Products
  public getComapreProducts(): Observable<any[]> {
    const itemsStream = new Observable(observer => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<DSProduct[]>>itemsStream;
  }

  // If item is aleready added In compare
  public hasProduct(product: any): boolean {
    const item = products.find(item => item.Id === product.id);
    return item !== undefined;
  }

  // Get Products By Slug
  public getProductBySlug(slug: string): Observable<any> {
    return this.products().pipe(map(items => {
      return items.find((item: any) => {
        return item.name.replace(' ', '-') === slug;
      });
    }));
  }

  // Add to compare
  public addToCompare(product: any): any | boolean {
    let message, status;
    let item: any | boolean = false;
    if (this.hasProduct(product)) {
      item = products.filter(item => item.id === product.id)[0];
      const index = products.indexOf(item);
      this.snackBar.open('The product  ' + product.name + ' already added to comparison list.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

    } else {
      if (products.length < 4) {
        products.push(product);
      }
      message = 'The product ' + product.name + ' has been added to comparison list.';
      status = 'success';
      this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });

    }
    sessionStorage.setItem('compareItem', JSON.stringify(products));
    return item;
  }

  // Removed Product
  public removeFromCompare(product: any) {
    if (product === undefined) { return; }
    const index = products.indexOf(product);
    products.splice(index, 1);
    sessionStorage.setItem('compareItem', JSON.stringify(products));
  }

  // Get Products By category
  public getProductByCategory(request?: any): Observable<any[]> {
    return this.products(request);
  }
  public getProductByAutoshipCategory(request?: any): Observable<any[]> {
    return this.autoshipProducts(request);
  }

  private init() {
    // Use sessionStorage instead of localStorage to prevent cart data caching across sessions
    if (sessionStorage.getItem('cart.packs')) {
      this.selectedPacks = JSON.parse(sessionStorage.getItem('cart.packs'));
    }
    if (sessionStorage.getItem('cart.order')) {
      this.selectedOrderItems = JSON.parse(sessionStorage.getItem('cart.order'));
    }
    if (sessionStorage.getItem('cart.autoship')) {
      this.selectedAutoOrderItems = JSON.parse(sessionStorage.getItem('cart.autoship'));
    }
    // Clean up any old localStorage cart data
    localStorage.removeItem('cart.packs');
    localStorage.removeItem('cart.order');
    localStorage.removeItem('cart.autoship');
    localStorage.removeItem('compareItem');
  }
  getItemRewardCurrency(item: any) {
    return item?.Prices?.find((price) => price.PriceCurrency === "RWD")?.Price || 0;
  }
  isLoggedIn(): boolean{
    let isLoggedIn = false;
    this.apiService.loginStatus.subscribe(val => {
      isLoggedIn =  val;
    });
    return isLoggedIn;
  }
}
